import React, { useContext } from 'react';
import Image from 'next/image';

import LastArticles from './lastArticles';
import LastArticlesLarge from './lastArticlesLarge';
import RecentPosts from './recentPosts';
import MostVisitedPost from './mostVisitedPost';
import NavBlog from './navBlog';
import SubscribeBlog from './subscribeBlog';
import BlogPagination from './blogPagination';
import AppContext from '../context/AppContext';

function BlogPage(props) {
 const { totalPagination } = useContext(AppContext);

 return (
  <div className='flex  flex-col w-full items-center justify-center bg-white text-white font-poppins'>
   <NavBlog />

   <div className='flex w-full items-center justify-center flex-col py-10 md:py-16 gap-2'>
    <h1 className='flex flex-col items-center justify-center text-center px-2 text- text-backbg text-hp5 tracking-wide  uppercase  '>
     <span className='  '>Le Guide Pratique </span>
     <span className='text-mainTwo '>du Développement Web </span>

     <span className=''> Tendances et Meilleures Techniques</span>
    </h1>

    <SubscribeBlog />
   </div>

   <div className='xg-orange-500 w-full max-w-7xl flex md:pb-10 '>
    {props.errList ? (
     <div className=' w-full flex items-center justify-center flex-col'>
      <div className='  flex items-center justify-center flex-col w-full py-20 '>
       <Image width={75} height={75} alt='' src='svg/loading.svg' className='   object-cover   ' />
      </div>
     </div>
    ) : (
     <div className=' flex items-center justify-start  flex-col w-full lg:w-2/3 gap-4 lg:gap-4 g-blue-300'>
      {props.err == '' && props.listArticles.listArticles_data && props.listArticles.listArticles_data.length != 0
       ? props.listArticles.listArticles_data.map((element, index) => {
          if (index % 3 !== 0 || index === 0) return <LastArticles key={element.title} data={element} />;
          else return <LastArticlesLarge key={element.title} data={element} />;
         })
       : ''}

      <BlogPagination total={props.listArticles.total} page={props.page} size={totalPagination} />
     </div>
    )}
    <div className='hidden lg:flex flex-col items-center justify-stat  w-1/3 px-10  gap-20 '>
     {props.errMost ? (
      <div className=' w-full flex items-center justify-center flex-col'>
       <div className='  flex items-center justify-center flex-col w-full py-20 '>
        <Image width={75} height={75} alt='' src='svg/loading.svg' className='   object-cover   ' />
       </div>
      </div>
     ) : (
      <MostVisitedPost mostViewArticles={props.mostViewArticles} err={props.err} />
     )}

     {props.errRecent ? (
      <div className=' w-full flex items-center justify-center flex-col'>
       <div className='  flex items-center justify-center flex-col w-full py-20 '>
        <Image width={75} height={75} alt='' src='svg/loading.svg' className='   object-cover   ' />
       </div>
      </div>
     ) : (
      <RecentPosts recentsArticles={props.recentsArticles} err={props.err} />
     )}
    </div>
   </div>

   <div className='flex md:hidden w-full items-center justify-center '>
    <SubscribeBlog />
   </div>
  </div>
 );
}

export default BlogPage;
